module.exports = __webpack_public_path__ + "img/porre_serrano.daa1f3e9.jpg";